import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Filters, FilterField } from './filters/filter';
import { MultiItemsAndStatusFilterField } from './filters/multi-items-and-status/filter-field-multi-items-and-status';
import { MultiSelectFilterField } from './filters/multi-select/filter-field-multi-select';
import { TabbedFilterField } from './filters/tabbed/filter-field-tabbed';
import { RadioFilterField } from './filters/radio/filter-field-radio';

@Component({
  selector: 'va-applied-filters-bar',
  template: `
    <div *ngIf="appliedFilters.length > 0" class="applied-filters-bar">
      <mat-chip-listbox>
        <ng-container *ngFor="let field of appliedFilters">
          <mat-chip-option *ngIf="!isArray(field.value)">
            {{ field.appliedFieldDisplayText() }}
            <mat-icon matChipRemove (click)="clearValue(field)">cancel</mat-icon>
          </mat-chip-option>
          <ng-container *ngIf="isArray(field.value)">
            <mat-chip-option *ngFor="let value of field.value" class="applied-filter-item">
              {{ field.appliedFieldDisplayText(value) }}
              <mat-icon matChipRemove (click)="clearValue(field, value)">cancel</mat-icon>
            </mat-chip-option>
          </ng-container>
        </ng-container>
      </mat-chip-listbox>
    </div>
  `,
  styleUrls: ['applied-filters-bar.component.scss'],
  standalone: false,
})
export class AppliedFiltersBarComponent {
  @Input() filters: Filters;
  @Output() fieldValueChanged = new EventEmitter();

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  get appliedFilters(): FilterField<any>[] {
    return this.filters.activeFields.filter(
      /* Exclude RadioFilterField because it always has a default value. It will mess up the applied filter bar
      If there are a lot of RadioFilterFields and remove the selected filter tag will not clear the filter*/
      (field) => !(field instanceof TabbedFilterField || field instanceof RadioFilterField),
    );
  }

  clearValue(field: FilterField<any>, value?: any): void {
    if (field instanceof MultiItemsAndStatusFilterField) {
      field.removeValue(value);
    } else if (field instanceof MultiSelectFilterField) {
      field.removeValue(value);
    } else {
      field.clearValue();
    }
    this.fieldValueChanged.emit(field);
  }
}
